<template>
  <div :class="`form-group c-editor ${error ? 'has-error' : ''}`" id="text-editor-wrapper">
    <label v-show="label" class="control-label">
      {{ label }}
      <span v-if="requiredMark" class="text-danger">*</span>
    </label>
    <textarea
      :value="value"
      :id="id || _uid"
      v-bind="$attrs"
      @blur="$emit('blur', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      class="form-control"
    ></textarea>
    <div v-if="snippets.length" style="margin-bottom: 5px;">
      <i>Available Code Snippets:</i>
      <br />
      <!-- snippets-->
      <span v-for="item in snippets" :key="item.value">
        <input
          type="button"
          :value="item.value"
          @click="insertSnippet(item.value)"
          data-toggle="tooltip"
          data-placement="top"
          rel="tooltip"
          :title="item.title"
          :disabled="!!disabled"
        />
      <i v-if="item.hint">{{item.hint}}</i>
      </span>
    </div>
    <small class="text-danger" v-if="error">{{ error }}</small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<script>
export default {
  props: {
    height:{
      type: Number,
      default: 200,
    },
    mode: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    snippets: {
      type: Array,
      default: () => []
    },
    requiredMark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      default: () => [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['fontNamesIgnoreCheck', ['Open Sans']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
        ['table', ['table']],
        ['insert', ['hr', 'link']],
        ['view', ['codeview']]
      ]
    }
  },
  emits: ['update:modelValue'],
  mounted() {
    const self = this

    $([`#${this.id || this._uid}`]).summernote({
      tabsize: 2,
      height: this.height,
      toolbar: this.toolbar,
      callbacks: {
        onInit: function() {
          if (self.mode === 'code') {
            $("div.note-editor button.btn-codeview").click();
          }
        },

        onChange: function(contents) {
          self.$emit('input', contents)
        },

        onPaste: function(e) {
          let bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text')

          e.preventDefault()

          setTimeout( () => {
            document.execCommand( 'insertText', false, bufferText )
          }, 10 )
        },

        onImageUpload: function(file) {
          const uploadCareHost = 'https://ucarecdn.com'

          $(`#text-editor-wrapper`).spin('small')

          let fileUpload = uploadcare.fileFrom('object', file[0])

          fileUpload.done((fileInfo) => {
            if (fileInfo.isImage) {
              let image = $('<img>')
                .attr('src', `${uploadCareHost}/${fileInfo.uuid}/-/format/auto/-/preview/800x600/-/stretch/off/`)
                .attr('style', 'width:100%;')

              $(`#${this.id}`).summernote("insertNode", image[0]);
            } else {
              let file = $('<a download>Download File</a>').attr('href', fileInfo.originalUrl)

              $(`#${this.id}`).summernote("insertNode", file[0]);
            }

            $(`#text-editor-wrapper`).spin(false)
          })
        }
      }
    })
  },
  methods: {
    insertSnippet(snippet) {
      $(`#${this.id || this._uid}`).summernote('editor.insertText', snippet)
    }
  }
}
</script>

<style lang="scss">
.c-editor {
  .note-editor.note-frame .note-editing-area .note-editable {
    padding-top: 30px;
  }
  .note-editor.note-frame {
    margin-bottom: 5px !important;
  }
  img {
    max-width: 100%;
  }
}

.has-error {
  .note-editor.note-frame {
    border: 1px solid #a94442 !important;
  }

  .panel-default > .panel-heading {
    background-color: rgba(169, 68, 66, 0.2);
    border-color: #a94442;
  }
}
</style>
